import React from 'react';
import moment from 'moment';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Field, reduxForm } from 'redux-form';

import IconButton from '@material-ui/core/IconButton';
import FormHelperText from '@material-ui/core/FormHelperText';

import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

import ConfirmContext from 'contexts/ConfirmContext';

import { DropDown, Input, TextIconButton, TimePicker } from 'components';

import { useStyles } from './styles';
import validate from './validate';

const TimeDuration = ({
  fields,
  disabledItemIndex,
  meta: { submitFailed, error }
}) => {
  const classes = useStyles();
  const confirm = React.useContext(ConfirmContext);
  const [t] = useTranslation();

  const onAddFieldHandler = () => {
    fields.push({ startTime: moment(), duration: null, timeType: 'hours' });
  };

  const onDeleteFieldHandler = index => {
    confirm({
      title: 'Are you sure you want to delete start time and duration?',
      confirmationText: 'Delete',
      cancellationText: 'Back'
    })
      .then(() => {
        fields.remove(index);
      })
      .catch(() => {});
  };

  const onDeleteAllFields = () => {
    confirm({
      title: 'Are you sure you want to delete all?',
      confirmationText: 'Delete',
      cancellationText: 'Back'
    })
      .then(() => {
        if (disabledItemIndex === 0 || disabledItemIndex) {
          const fieldCopy = fields.get(disabledItemIndex);
          fields.removeAll();
          fields.push(fieldCopy);
        } else {
          fields.removeAll();
        }
      })
      .catch(() => {});
  };

  return (
    <div>
      <div className={classNames(classes.row, classes.buttonsGroup)}>
        <TextIconButton
          icon={<AddCircleOutlineIcon />}
          text={t('Add new')}
          click={onAddFieldHandler}
        />

        {fields.length > 1 && (
          <TextIconButton
            icon={<DeleteOutlineIcon />}
            text={t('Delete all')}
            click={onDeleteAllFields}
          />
        )}
      </div>

      {fields.map((field, index) => (
        <div key={index} className={classes.timeDurationRow}>
          <div className={classNames(classes.row)}>
            <div className={classes.timePickerWrapper}>
              <Field
                name={`${field}.startTime`}
                label="Start time *"
                component={TimePicker}
              />
            </div>
            <Field
              name={`${field}.duration`}
              isOnlyNumber={true}
              maxLength={9}
              placeholder="Duration"
              isHiddenErrorMsg={error && error[index]}
              label="Duration"
              className={classes.inputWrapper}
              component={Input}
            />
            <div className={classes.dropDownWrapper}>
              <Field
                name={`${field}.timeType`}
                isHiddenErrorMsg={true}
                list={['minutes', 'hours', 'days', 'weeks']}
                component={DropDown}
              />
            </div>
            {fields.length > 1 && (
              <IconButton
                classes={{ sizeSmall: classes.deleteIcon }}
                size="small"
                aria-label="delete"
                onClick={() => onDeleteFieldHandler(index)}
              >
                <DeleteOutlineIcon />
              </IconButton>
            )}
          </div>
          {submitFailed && error && error[index] && (
            <FormHelperText error>{t(error[index])}</FormHelperText>
          )}
        </div>
      ))}
    </div>
  );
};

export default reduxForm({
  form: 'scheduleDateTimeForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
  touchOnBlur: false,
  validate
})(TimeDuration);
